module.exports = __webpack_public_path__ + "img/gris-3.d7927c15.png";